
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { showDeleteConfirmation, showSubmitConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
import { getAttachmentPayloads, validateSalesInteger } from "../../../SharedFiles/Helper/utils";
import { GetdocType, PostSalesOrder, PotingSaleData, UpdateSalesOrder, UpdateSalesQuotation } from "../../../APIServices/SalesService/OrderService/OrderThunk";
import { useDispatch, useSelector } from "react-redux";
import { decryptUserInfo } from "../../../SharedFiles/decryption/Decryption";

const useOrderLogic = () => {
  const userData = sessionStorage.getItem("user");
  const parsedUserData = userData ? JSON.parse(userData) : null;
  const decryptedUserInfo = parsedUserData && decryptUserInfo(parsedUserData);
  const userId = decryptedUserInfo && decryptedUserInfo[0].USERID;
  const category = decryptedUserInfo && decryptedUserInfo[0].CATEGORY;
  const dispatch = useDispatch();
  const [attachments,setAttachments]=useState([]);
  const [cartItems, setCartItems] = useState([]);
  const [customerForm, setCustomerForm] = useState({
    customerName: "",
    address: "",
    contactNumber: "",
    remarks: "",
    customerCode: "",
    addressShort: "",
    poNum:"",
  });
  const [editing, setEditing] = useState(false);
  const [customerData, setCustomerData] = useState("");
  const [OrderType, setOrderType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [quantity, setQuantity] = useState("");
  const [quantityNos, setQuantityNos] = useState("");
  const [type, setType] = useState("bundle");
  const [isCheckout, setIsCheckout] = useState(false);
  const [showItemData, setShowItemData] = useState(false);
  const [InProgress, setInProgress] = useState({
    FetchItemGroup: false,
    FetchItem: false,
    fetchCustomer: false,
    PostSales: false,
    PostSQ: false,
    UpdateSO: false,
    UpdateSaleSQ: false,
    FetchSearchItem: false,
    fetchQuoteImage:false,
    deleteSQandSO:false
  });
  console.log("form",customerForm);
  // useEffect(() => {
  //   const storedCartItems = sessionStorage.getItem("cartItems");
  //   if (storedCartItems) {
  //     setCartItems(JSON.parse(storedCartItems));
  //   }
  //   if (editing) {
  //     const Parsed = JSON.parse(sessionStorage.getItem("cartItems"));
  //     setCartItems(Parsed);
  //     setCustomerForm({
  //       customerName: `${Parsed[0].Customer_Code} - ${Parsed[0].address}`,
  //       address: Parsed[0].address,
  //       contactNumber: Parsed[0].contactNumber || "",
  //       remarks: Parsed[0].remarks || "",
  //       customerCode: Parsed[0].Customer_Code,
  //       addressShort: Parsed[0].shortAddress,
  //     });

  //   }
  // }, [editing]);
  const openModal = (item) => {
    setSelectedItem(item);
    setShowModal(true);
    const existingItemIndex = cartItems?.findIndex(
      (cartItem) => cartItem.item_Code === item.item_Code
    );
    if (existingItemIndex !== -1) {
      const existingItem = cartItems[existingItemIndex];
      // setSelectedItem(existingItem); 
      setQuantityNos(existingItem.quantityNos);
      setQuantity(existingItem.quantity);
      setType(existingItem.type);
    } else {
      setQuantity("");
      setQuantityNos("");
      setType("bundle"); // or whatever default you want
    }

  };
  useEffect(() => {
    if (quantity !== '') {
      handleQtyChange(quantity);
    }
  }, [quantity]);

  const closeModal = () => {
    setShowModal(false);
    setSelectedItem(null);
    setQuantity("");
    setQuantityNos("");
  };
  // const handleQtyChange = (value) => {
  //   const noinbundleValue = parseInt(selectedItem?.noinbundle, 10) || 0;
  //   if (value===''||validateSalesInteger(value)&&!editing) {
  //   if (type === 'bundle') {
  //       const numericValue = parseInt(value, 10) || 0;
  //       const result = parseInt(value * noinbundleValue);
  //       setQuantity(value);
  //       setQuantityNos(result);
  //   } else {
  //     const numericValue = parseFloat(value) || 0;
  //     const result = noinbundleValue !== 0 ? (numericValue / noinbundleValue).toFixed(2) : "0.00";
  //     setQuantity(value);
  //     setQuantityNos(result);
  //   }
  // }
  // };
  const handleQtyChange = (value) => {
    const noinbundleValue = parseInt(selectedItem?.noinbundle, 10) || 0;
    const isValidInput = editing || validateSalesInteger(value);
    if (value === '' || isValidInput) {
      if (type === 'bundle') {
        const numericValue = parseInt(value, 10) || 0;
        const result = parseInt(value * noinbundleValue);
        setQuantity(value);
        setQuantityNos(result);
      } else {
        const numericValue = parseFloat(value) || 0;
        const result = noinbundleValue !== 0 ? (numericValue / noinbundleValue).toFixed(2) : "0.00";
        setQuantity(value);
        setQuantityNos(result);
      }
    }
  };
  const addToCart = (item) => {
    if (quantity <= 0) {
      alert("Quantity must be greater than 0."); // You can replace this with a more user-friendly error message
      return; // Prevent adding to the cart if quantity is invalid
    }
    const existingItemIndex = cartItems.findIndex(
      (cartItem) => cartItem.item_Code === selectedItem.item_Code
    );
    let updatedCartItems;

    if (existingItemIndex !== -1) {
      // If item already exists, update the quantity
      updatedCartItems = [...cartItems];
      updatedCartItems[existingItemIndex].quantity = quantity;
      updatedCartItems[existingItemIndex].quantityNos = quantityNos;
      updatedCartItems[existingItemIndex].type = type;
    } else {
      updatedCartItems = [
        ...cartItems,
        {
          ...selectedItem,
          quantity: quantity,
          quantityNos: quantityNos,
          type: type,
        },
      ];
    }
    setCartItems(updatedCartItems);
    sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    setShowModal(false);
    setShowItemData(false);
  };
  const removeFromCart = (itemCode) => {
    showDeleteConfirmation(() => {
      const updatedCartItems = cartItems.filter(
        (item) => item.item_Code !== itemCode
      );
      setCartItems(updatedCartItems);
      sessionStorage.setItem("cartItems", JSON.stringify(updatedCartItems));
    });
  };

  const handlePlaceOrder = () => {
    dispatch(GetdocType())
    if (!isCheckout) {
      setIsCheckout(true);
    }
  };
  const handleConfirmOrder = (orderType) => {
      if (!editing && !customerData.card_Code) {
      toast.error("Customer Code is required to confirm the order.");
      return;
    }
    
    showSubmitConfirmation(async() => {
      const dataList = [{
        orderType : orderType,
        customerCode: customerForm.customerCode,
        DeliveryDate: "07/04/2025",
        BranchId: 1,
        Remarks: customerForm.remarks,
        DocType:customerForm?.docType,
        itemDetails: cartItems.map((item) => {
          const isBundle = item.type === "bundle";
          return {
            ItemCode: item.item_Code,
            lineNum: item.lineNum >=0 ? item.lineNum : -1,
            weight: isBundle ? item.quantityNos * item.barWeight : item.quantity * item.barWeight,
            Quantity: isBundle ? item.quantityNos : item.quantity,
            noinbundle: isBundle ? item.quantity : item.quantityNos,
            WareHouseCode: "FG",
            ShipAddress: customerForm.addressShort ? customerForm.addressShort : "",
            priority: item.priority ? "Y" : "N",
          };
        }),
        SplCode: category === "S1" ? userId : -1,
        customerPO:customerForm.poNum || "",
        attachments: await getAttachmentPayloads(attachments), 
      }];
      // setInProgress({ ...InProgress, PostSales: true });
      // setisLoading(true);
      // dispatch(PostSalesOrder(dataList));
      let dataToSend;
      
      setOrderType(orderType);
      try {
        if (orderType === "quotation" || orderType === "order") {          
          if (isCheckout) {
            setInProgress({ ...InProgress, PostSQ: true });
            dataToSend = dataList
            dispatch(PotingSaleData(dataToSend));
          } 
        } else if(orderType === "Update Quotation"){
          const DocEntry = sessionStorage.getItem("DocEntry")
          dataToSend = {
            docEntry: DocEntry,
            dataList: dataList
          }
          setInProgress({ ...InProgress, UpdateSaleSQ: true });
          dispatch(UpdateSalesQuotation(dataToSend));
        }
        // else if (orderType === "order") {
        //   dataToSend = dataList
        //   // setInProgress({ ...InProgress, PostSales: true });
        //   setInProgress({ ...InProgress, PostSQ: true });
        //   // dispatch(PostSalesOrder(dataToSend))
        //   dispatch(PotingSaleData(dataToSend));
        // }
         else if (orderType === "Update Order") {
          const DocEntry = sessionStorage.getItem("DocEntry")
          dataToSend = {
            docEntry: DocEntry,
            dataList
          }
          setInProgress({ ...InProgress, UpdateSaleSQ: true });
          dispatch(UpdateSalesQuotation(dataToSend))
        }

      } catch (error) {
        setInProgress({ ...InProgress, UpdateSaleSQ: false,PostSQ: false,PostSales: false });
      }
    });
  };

  return {
    cartItems,
    setCartItems,
    showModal,
    setShowModal,
    openModal,
    closeModal,
    selectedItem,
    setSelectedItem,
    editing,
    setEditing,
    quantity,
    quantityNos,
    type,
    handleConfirmOrder,
    customerForm, setCustomerForm,
    handlePlaceOrder, customerData, setCustomerData,
    setType,
    setQuantity,
    setQuantityNos,
    handleQtyChange, setOrderType,OrderType,
    showItemData, setShowItemData,
    isCheckout, setIsCheckout,
    InProgress, setInProgress,setAttachments,attachments,
    addToCart,
    removeFromCart,
  };
};

export default useOrderLogic;

